module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Light.78a89362a2882b06519fed693f49c877.woff2";